import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import GeneralVoucherCodeReportCard from "../../../admin/components/report/GeneralVoucherCodeReportCard";
import UniqueVoucherCodeReportCard from "../../../admin/components/report/VoucherCodeReportCard";

const VoucherCodeReport = ({ token, client }) => {

    const history = useHistory();

    const [toggled, setToggled] = useState(false);

    useEffect(() => {
        if (!client || !client.voucher_code_report) {
            history.push("/client");
        }
    }, []);

    const handleToggle = () => {
        setToggled(!toggled);
    };

    return (
        <div className="admin-page-container">
            <Sidebar toggled={toggled} setToggled={handleToggle} />
            <div className="admin-page">
                <Topbar handleToggle={handleToggle} />
                <div className="admin-content">
                    <GeneralVoucherCodeReportCard 
                        role="client"
                        token={token}
                        operators={client.admin}
                        distributors={client.distributor}
                    />

                    <UniqueVoucherCodeReportCard
                        role="client"
                        token={token}
                        operators={client.admin}
                        distributors={client.distributor}
                    />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    client: state.client.client,
    token: state.client.token,
});

export default connect(mapStateToProps)(VoucherCodeReport);